<template>
<ul class="card-details" v-if="pony">
  <li class="card-detail" v-if="pony.averagePrice > 0">
    <span class="elr-card-list-label">Average Price:</span>
    {{currency(pony.averagePrice)}}
  </li>
  <li v-if="pony.mold" class="card-detail">
    <span class="elr-card-list-label">Mold: </span>
    <router-link :to="`/mold/${pony.mold.slug}`">{{capitalize(pony.mold.name)}}</router-link>
  </li>
  <li v-if="pony.generation" class="card-detail">
    <span class="elr-card-list-label">Generation: </span>
    <router-link :to="`/generation/${pony.generation.slug}`">{{capitalize(pony.generation.name)}}</router-link>
  </li>
  <li v-if="pony.grouping" class="card-detail">
    <span class="elr-card-list-label">Grouping: </span>
    <router-link :to="`/grouping/${pony.grouping.slug}`">{{capitalize(pony.grouping.name)}}</router-link>
  </li>
  <li v-if="pony.origin" class="card-detail">
    <span class="elr-card-list-label">Origin: </span>
    <router-link :to="`/origin/${pony.origin.slug}`">{{capitalize(pony.origin.name)}}</router-link>
  </li>
  <li v-if="pony.release" class="card-detail">
    <span class="elr-card-list-label">Release Type: </span>
    <router-link :to="`/release/${pony.release.slug}`">{{capitalize(pony.release.name)}}</router-link>
  </li>
  <li v-if="pony.year" class="card-detail">
    <span class="elr-card-list-label">Year Made: </span>
    <router-link :to="`/year/${pony.year.slug}`">{{capitalize(pony.year.year_made)}}</router-link>
  </li>
  <li v-if="pony.pose" class="card-detail">
    <span class="elr-card-list-label">Pose: </span>
    <router-link :to="`/pose/${pony.pose.slug}`">{{capitalize(pony.pose.name)}}</router-link>
  </li>
  <li v-if="pony.body_color" class="card-detail">
    <span class="elr-card-list-label">Color: </span>
    <router-link :to="`/body-color/${pony.body_color.slug}`">{{capitalize(pony.body_color.name)}}</router-link>
  </li>
  <li v-if="pony.themes" class="card-detail">
    <span class="elr-card-list-label">Themes: </span>
    <span v-for="(theme, index) in pony.themes" :key="theme.slug"><router-link :to="`/theme/${theme.slug}`">{{capitalize(theme.name)}}</router-link>{{index !== pony.themes.length - 1 ? ', ': ''}}</span>
  </li>
</ul>
</template>

<script>
import { capitalize, currency } from '../../utils/helpers';

export default {
  name: 'PonyCardDetails',
  props: {
    pony: {
      type: Object,
      required: true
    }
  },
  methods: {
    currency,
    capitalize
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/_config.scss';

.card-details {
  padding-top: 10px;
  padding-bottom: 10px;
  list-style: none;
  padding-left: 10px;
}

.card-detail {
  font-size: 14px;
  padding-top: 7px;
  padding-bottom: 7px;
}

.elr-card-list-label {
  color: $text-color;
  font-weight: 900;
}
</style>
